import axios from 'axios';
import { getAuthHeader } from '../global_helpers/authHeader.js';
import { getTPAID } from '../global_helpers/sessionReturn.js';
import {
    OpportunitySection,
    PlanTypeSection,
    CashBalanceSection,
    RevShareSection,
    ProviderSection,
    TemplateSection,
    BrokerSection,
    AdvisorSection,
    PricingSection,
    PricingOptions,
    createPricingTable,
    createPricingTableItem,
} from './proposalBuilderSections.js'
import { defaultPricingTable, updatePricingTablePreviews, handleThousandFormat } from '../global_helpers/utility.js';

const state = {
    opportunitySection: new OpportunitySection(),
    planTypeSection: new PlanTypeSection(),
    cashBalanceSection: new CashBalanceSection(),
    revShareSection: new RevShareSection(),
    providerSection: new ProviderSection(),
    templateSection: new TemplateSection(),
    brokerSection: new BrokerSection(),
    advisorSection: new AdvisorSection(),
    pricingSection: new PricingSection(),
    pricingOptions: new PricingOptions(),
    savedBrokerDealerIsNoBroker: false,
    savedSelectedPrograms: [],
    savedAdvisor: null,
    savedPricingSection: null,
    isUpdate: false,
    legacyProposalsIds: [],
    lastPricingTablePresetState:undefined,
    tablePresets:defaultPricingTable(),
    dataContext:null,
    savedSelectedPricingTable: "",
    savedPricingTables: [],

    proposalViewModels: [],
    savedProposals: [],
    proposalTemplates: [],
    showSection: {
        cashBalance: false,
        revShare: false,
        provider: false,
        template: false,
        broker: false,
        advisor: false,
        pricing: false,
    },
    isPDFGenerated: false,
    takeover: new PricingSection(),
    startup_sh: new PricingSection(),
    startup_nsh: new PricingSection(),
    cashbalance: new PricingSection(),
};

const getters = {
    getOpportunitySection: (state) => state.opportunitySection,
    getPlanTypeSection: (state) => state.planTypeSection,
    getCashBalanceSection: (state) => state.cashBalanceSection,
    getRevShareSection: (state) => state.revShareSection,
    getProviderSection: (state) => state.providerSection,
    getTemplateSection: (state) => state.templateSection,
    getBrokerSection: (state) => state.brokerSection,
    getAdvisorSection: (state) => state.advisorSection,
    getPricingSection: (state) => state.pricingSection,
    getPricingOptions: (state) => state.pricingOptions,
    getShowSection: (state) => state.showSection,
    getProposalViewModels: (state) => state.proposalViewModels,
    getSavedProposals: (state) => state.savedProposals,
    getProposalTemplates: (state) => state.proposalTemplates,
    getIsPDFGenerated: (state) => state.isPDFGenerated,
    getSavedSelectedPrograms: (state) => state.savedSelectedPrograms,
    getSavedAdvisor: (state) => state.savedAdvisor,
    getSavedBrokerDealerIsNoBroker: (state) => state.savedBrokerDealerIsNoBroker,
    getSavedPricingSection: (state) => state.savedPricingSection,
    getIsUpdate: (state) => state.isUpdate,
    getLegacyProposalsIds: (state) => state.legacyProposalsIds,
    getTablePresetItems: (state) => state.tablePresets,
    getDataContext: (state) => state.dataContext,
    getSavedPricingTables: (state) => state.savedPricingTables,
    getLastPricingTablePresetState: (state) => state.lastPricingTablePresetState,
    getSavedSelectedPricingTable: (state) => state.savedSelectedPricingTable,
    getTakeover: (state) => state.takeover,
    getStartup_sh: (state) => state.startup_sh,
    getStartup_nsh: (state) => state.startup_nsh,
    getCashbalance: (state) => state.cashbalance
};

const actions = {
    async clearProposalBuilderState({ commit }) {
        commit('clearProposalBuilderState');
    },

    async clearProposalViewModels({ commit }) {
        commit('clearProposalViewModelsState');
    },
    
    
    updateProposalViewModels({ commit }, data) {
        commit('setProposalViewModels', data);
    },

    async clearSavedProposalsState({ commit }) {
        commit('clearSavedProposalsState');
    },

    setIsUpdate({ commit }, data) {
        commit('setIsUpdateState', data);
    },

    initTablePricing({ commit }) {
        commit('setInitTablePricing');
    },

    updateTablePreset({ commit }, data) {
        commit('setUpdateTablePreset', data);
    },
    updatelastTablePricingState({ commit }, data) {
        commit('updatelastTablePricingStateState', data);
    },
    clearSavedSelectedPricingTable({commit}){
        commit('clearSavedSelectedPricingTableState');
    },

    async loadRevSharePrograms({ commit }) {
        console.log('loadRevSharePrograms');
        axios.get('/recordkeeper/', getAuthHeader())
            .then(response => {
                commit('loadRevShareProgramsState', response.data);
            })
    },

    async loadProposalTemplates({ commit }) {
        console.log('loadProposalTemplates');
        let authHeader = getAuthHeader();
        const response = await axios.get(`/template/list/?entity_type=tpa&entity_id=${getTPAID()}&template_type=proposal`, authHeader)
        commit('loadProposalTemplatesState', response.data);
    },

    async loadPricingTables({commit}) {
        console.log('loadPricingTables');
        const response = await axios.get('/pricing_table/list/', getAuthHeader())
        commit('loadPricingTablesState', response.data);
    },

    async savePricingTables({dispatch},pricingTable) {
        try{
           const selectedTokens = { data: state.tablePresets.entries.map(v => {return {token: v.token, description: v.name, section: v.section, active: v.active}}) }
            pricingTable.selectedTokens = selectedTokens
            const resp = await axios.post('/pricing_table/', pricingTable, getAuthHeader())
            return resp.data.pricing_table_id
        } catch(err) {
            console.log(err);
            dispatch('raiseMessage', 'There was an error saving pricing table.');
        }   
    },

    async updatePricingTable({dispatch},pricingTable) {
        try{
            const selectedTokens = { data: state.tablePresets.entries.map(v => {return {token: v.token, description: v.name, section: v.section, active: v.active}}) }
            pricingTable.selectedTokens = selectedTokens
            const resp = await axios.put(`/pricing_table/`, pricingTable, getAuthHeader())
            return resp.data.pricing_table_id
        } catch(err) {
            console.log(err);
            dispatch('raiseMessage', 'There was an error updating pricing table.');
        }
    },
    
    async deletePricingTable({dispatch},pricingTableId) {
        try{
            await axios.delete(`/pricing_table/?pricing_table_id=${pricingTableId}`, getAuthHeader())
        } catch(err) {
            console.log(err);
            dispatch('raiseMessage', 'There was an error deleting pricing table.');
        }
    },


    
    async loadWholesalerTemplatePairs({ commit }, data) {
        let authHeader = getAuthHeader();
        let tpaId = getTPAID();
        axios.get(`/wholesaler/ddl/?entity_type=tpa&entity_id=${tpaId}&rk_id=${data}`, authHeader)
            .then(response => {
                commit('updateWholesalerTemplateState', response.data);
            });
    },

    async loadDefaultPricing({ commit }, arg) {
        console.log('loadDefaultPricing');
        let authHeader = getAuthHeader();
        let tpaId = getTPAID();
        axios.get(`/pricing_default/selections/?entity_type=tpa&entity_id=${tpaId}&plan_type=${arg.planType}`, authHeader)
            .then(response => {
                commit('loadDefaultPricingState', response.data);
                arg.callback();
            })
    },

    async loadDefaultPricingOptions({ commit }) {
        console.log('loadDefaultPricingOptions');
        let authHeader = getAuthHeader();
        let tpaId = getTPAID();
        axios.get(`/pricing_default/options/?entity_type=tpa&entity_id=${tpaId}&plan_type=takeover`, authHeader)
            .then(response => {
                commit('loadDefaultPricingOptionsState', response.data);
            })
    },

    async loadBrokerDealers({ commit }) {
        console.log('loadBrokerDealers');
        let authHeader = getAuthHeader();
        let tpaId = getTPAID();
        const response = await axios.get(`/broker/list/?tpa_id=${tpaId}`, authHeader)
        commit('loadBrokerDealersState', response.data);
    },

    async clearBrokerState({ commit }) {
        console.log('clearBrokerState called');
        commit('clearBrokerState');
    },

    async updateBrokerDefaults({ dispatch }, defaults) {
        // console.log('updateBrokerDefaults called');
        let authHeader = getAuthHeader();
        let tpaId = getTPAID();
        // console.log(defaults);
        let body = { broker_ids: defaults };
        axios.put('/broker/default/?tpa_id=' + tpaId, body, authHeader)
            .catch((err) => {
                console.log(err);
                dispatch('raiseMessage', 'There was an error updating your default brokers.');
            });
    },

    async loadAdvisorState({ commit }, id) {
        console.log('loadAdvisorState called');
        console.log(id);
        let tpa_id = getTPAID();
        let authHeader = getAuthHeader();
        const res = await axios.get("/advisor/list/?broker_id=" + id + "&tpa_id=" + tpa_id, authHeader)
        commit('setAdvisorState', res.data);
    },

    setTablePreset({commit}, data){
        commit("setTablePresetState", data)
    },

    async clearAdvisorState({ commit }) {
        console.log('clearAdvisorState called');
        commit('clearAdvisorState');
    },

    clearSavedProgramsState({ commit }) {
        console.log('clearSavedProgramsState called');
        commit('clearSavedSelectedProgramsState');
    },

    clearSavedAdvisor({ commit }) {
        console.log('clearSavedAdvisorState called');
        commit('clearSavedAdvisorState');
    },

    loadTablePricingData({commit}){
        commit("loadTablePricingDataState")
    },
    setPdfGenerated({commit}, isPDFGenerated){
        commit('setIsPDFGenerated', isPDFGenerated);
    },

    clearSavedBrokerDealerIsNoBroker({ commit }) {
        console.log('clearSavedBrokerDealerIsNoBroker called');
        commit('clearSavedBrokerDealerIsNoBrokerState');
    },

    clearAllSavedProposal({ commit }) {
        console.log('clearSavedAdvisorState called');
        commit('clearAllSavedProposalState');
    },

    async getProposalViewModelCalculation({ commit, dispatch }, proposalViewModel) {
        try{

            let authHeader = getAuthHeader();
            const res = await axios.post('/proposal/viewmodel/calculations/', proposalViewModel, authHeader)
            commit('appendProposalViewModel', res.data)
        }
        catch(err){
            console.log(err)
            dispatch('raiseMessage', 'There was an error rendering your calculations', { root: true });
        }
    },

    async getProposalViewModelCalculation2({ commit, dispatch }, proposalViewModel) {
        try{
            let authHeader = getAuthHeader();
            const res = await axios.post('/proposal/viewmodel/calculations/', proposalViewModel, authHeader)
            commit('setTablePresetState', res.data)
        }
        catch(err){
            console.log(err)
            dispatch('raiseMessage', 'There was an error rendering your calculations', { root: true });
        }
    },

    async saveProposalViewModels({ commit, dispatch }, callback) {
        console.log(`saveProposalViewModels called`);
        let authHeader = getAuthHeader();
        let requests = [];
        let proposals = [];
        const selectedTokens = { data: state.tablePresets.entries.map(v => {return {token: v.token, description: v.name, section: v.section, active: v.active}}) }
        commit('setIsPDFGenerated', true);
        state.proposalViewModels.forEach(vm => {
            vm.selectedTokens = selectedTokens
            vm.pricingTableId = state.tablePresets.pricing_table_id
            requests.push(axios.post('/proposal/viewmodel/save/', vm, authHeader));
        })
        await axios.all(requests)
            .then(axios.spread((...res) => {
                res.forEach(r => proposals.push(r.data));
            })
            )
            .catch(err => {
                console.log(err)
                dispatch('raiseMessage', 'There was an error saving your proposal(s)!', { root: true });
            });
        commit('setSavedProposalsState', proposals);
        callback(); //used to send the email after the proposals are all saved
    },
    
    async deleteAllsavedProposal( obj ,planOpportunityId){
        let authHeader = getAuthHeader();
        console.log(`planOpportunityId = ${planOpportunityId}}`)
        axios.delete("/proposal/proposal_builder/?plan_opportunity_id="+ planOpportunityId, authHeader)
    },

    async loadSavedProposalBuilder({ commit }, data) {
        let authHeader = getAuthHeader();
        let tpaId = getTPAID();
        const savedProposalBuilderResponse = await axios.get('proposal/proposal_builder/?plan_opportunity_id=' + data, authHeader)
        const savedProposalBuilder = savedProposalBuilderResponse.data
        if (savedProposalBuilder) {
            const selectedPrograms = savedProposalBuilder.record_keeper.multiQuote ? savedProposalBuilder.record_keeper.selected_programs : savedProposalBuilder.record_keeper.selected_programs[0]
            const newData = {
                'revSharePrograms': [...state.revShareSection.revSharePrograms],
                'multiQuote': savedProposalBuilder.record_keeper.multiQuote,
                'selected_programs': selectedPrograms
            }
            const revShare = new RevShareSection(newData)
            if (newData) {
                const response = await axios.get(`/wholesaler/ddl/?entity_type=tpa&entity_id=${tpaId}&rk_id=${revShare.rk_ids}`, authHeader)
                savedProposalBuilder.wholesalers = response.data
                if (savedProposalBuilder.broker.broker_dealer_name === 'No Broker Dealer') {
                    const borkerId = savedProposalBuilder.broker.broker_id
                    const advisors = await axios.get("/advisor/list/?broker_id=" + borkerId + "&tpa_id=" + tpaId, authHeader)
                    savedProposalBuilder.advisors = advisors
                }
                commit('setPlanType', savedProposalBuilder)
            } else {
                commit('clearSavedPricingSectionState', {})
            }
        }

    }
};

const mutations = {
    clearProposalBuilderState(state) {
        state.planTypeSection = new PlanTypeSection();
        state.cashBalanceSection = new CashBalanceSection();
        state.revShareSection = new RevShareSection();
        state.providerSection = new ProviderSection();
        state.brokerSection = new BrokerSection();
        state.advisorSection = new AdvisorSection();
        state.pricingSection = new PricingSection();
        state.proposalViewModels = [];
        state.showSection = {
            cashBalance: false,
            revShare: false,
            provider: false,
            broker: false,
            advisor: false,
            pricing: false,
        };
        state.isPDFGenerated = false;
        state.isUpdate = false;
    },

    clearSavedProposalsState(state) {
        state.savedProposals = [];
    },

    setPlanType(state, data) {
        const newPlan = new PlanTypeSection(data.parent_type)
        state.planTypeSection = newPlan

        if (state.planTypeSection.isCBType) {
            state.cashBalanceSection.CBType = data.parent_type.cb_type
            state.cashBalanceSection._planType = state.planTypeSection.ParentType;
            if (state.planTypeSection.isCBOnly) {
                state.planTypeSection.setDisplayName(state.cashBalanceSection.CBType);
                if (state.cashBalanceSection.Template === null) {
                    state.cashBalanceSection.Template = data.providerSection[0].selected_template
                }
            }
        } 

        if (state.planTypeSection.IsNoRevenueShare && state.templateSection.Template === null) {
            state.templateSection.Template = data.providerSection[0].selected_template
        }

        
        state.revShareSection.multiQuote = data.record_keeper.multiQuote

        const selectedPrograms = state.revShareSection.revSharePrograms.filter(rp => data.record_keeper.selected_programs.find(sp => sp.rk_id == rp.rk_id))
        const formatedSelectedPrograms = (selectedPrograms.length == 1 && !data.record_keeper.multiQuote) ? selectedPrograms[0] : selectedPrograms
        state.revShareSection.selected_programs = formatedSelectedPrograms
        state.savedSelectedPrograms = formatedSelectedPrograms

        state.legacyProposalsIds = data.proposals_ids

        state.providerSection.load(data.wholesalers)
        const fiteredProviderSection = data.providerSection.filter((item, index) => index === data.providerSection.findIndex(obj => item.wholesaler_id === obj.wholesaler_id))

        state.providerSection.wholesalerTemplates.map(p => {
            const wholesaler = fiteredProviderSection.find(item => item.wholesaler_id == p.wholesaler_id)
            if (wholesaler) {
                p.selected_template = wholesaler.selected_template
                p.selected_rep_user = p.rep_users.find(wt => wt.rep_user_id == wholesaler.selected_rep_user)
            }
        })

        if (state.brokerSection.radioOptions.length > 0) {
            let selectedBroker = state.brokerSection.radioOptions.find(b => b.broker_id == data.broker.broker_id)
            if (!selectedBroker)
                selectedBroker = state.brokerSection.dropDownOptions.find(b => b.broker_id == data.broker.broker_id)
            if (selectedBroker)
                state.brokerSection.radioSelected = selectedBroker
            else if (data.broker.broker_dealer_name === 'No Broker Dealer' && state.brokerSection.no_broker_dealer.broker_id === data.broker.broker_id) {
                state.brokerSection.broker_selected = state.brokerSection.no_broker_dealer
                state.brokerSection.is_no_broker = true
                state.brokerSection.confirmNoBroker = false
                state.savedBrokerDealerIsNoBroker = true
                state.advisorSection.brokerSelected = state.brokerSection.no_broker_dealer
            }
        }

        state.savedAdvisor = data.advisor

        const dataPricingAsumtion = {
            pricing_assumptions: data.pricing_assumptions,
            standard_fees: data.standard_fees,
            mep_pricing: data.mep_pricing,
            plan_doc_maint: data.plan_doc_maint,
            audit_fee: data.audit_fee,
            three_sixteen: data.three_sixteen,
            pbgc: data.pbgc,
            payroll_integration: data.payroll_integration,
            payroll_processing: data.payroll_processing,
            custom_additions: data.custom_additions,
            custom_notes: data.custom_notes,

        }

        state.savedPricingSection = {
            dataPricingAsumtion: dataPricingAsumtion
        }

        if(data.pricing_table_id){
            state.savedSelectedPricingTable = data.pricing_table_id 
            const selectedPricngTable = state.savedPricingTables.find(v=>v.pricing_table_id == data.pricing_table_id)
            state.tablePresets = selectedPricngTable
        }else{
            state.savedSelectedPricingTable = ""
        }
        if(!data.pricing_table_id && data.selectedTokens && data.selectedTokens.length>0){
            const entries = data.selectedTokens.map(v => {
                const item = {
                    name: v.description,
                    section: v.section,
                    token: handleThousandFormat(v.value),
                    active: v.active,

                }
                return createPricingTableItem(item)
            })
            state.tablePresets.entries = entries
        }
    },

    setSavedProposalsState(state, data) {
        console.log('setSavedProposalsState mutation called');
        state.savedProposals = data;
    },

    setIsPDFGenerated(state, value) {
        state.isPDFGenerated = value;
    },

    clearProposalViewModelsState(state) {
        state.proposalViewModels = [];
    },

    clearSavedSelectedProgramsState(state) {
        state.savedSelectedPrograms = [];
    },

    clearSavedBrokerDealerIsNoBrokerState(state) {
        state.savedBrokerDealerIsNoBroker = null;
    },

    setIsUpdateState(state, data) {
        state.isUpdate = data;
    },
    setInitTablePricing(state) {
        state.tablePresets = defaultPricingTable()
    },
    setUpdateTablePreset(state, data) {
        state.tablePresets = data;
    },
    updatelastTablePricingStateState(state, data) {
        state.lastPricingTablePresetState = data;
    },

    clearSavedAdvisorState(state) {
        state.savedAdvisor = null;
    },

    clearSavedPricingSectionState(state) {
        state.savedPricingSection = null
    },

    setTablePresetState(state, data) {
        state.dataContext = data.context
        state.tablePresets.entries = state.tablePresets.entries.map(item =>{
            if(item.token){
                updatePricingTablePreviews(state.dataContext, state.tablePresets)
            }
            return item
        })
    },
    loadTablePricingDataState(state){
        state.tablePresets.entries = state.tablePresets.entries.map(item =>{
            if(item.token){
                updatePricingTablePreviews(state.dataContext, state.tablePresets)
            }
            return item
        })
    },

    clearAllSavedProposalState(state) {
        state.savedPricingSection = null
        state.savedAdvisor = null
        state.savedSelectedPrograms = []
        state.savedBrokerDealerIsNoBroker = null;
    },


    appendProposalViewModel(state, data) {
        console.log('appendProposalViewModel mutation called');
        state.proposalViewModels.push(data);
    },

    setProposalViewModels(state, data) {
        state.proposalViewModels = data;
    },

    loadProposalTemplatesState(state, data) {
        state.proposalTemplates = data
        data.forEach(t => {
            if (t.is_default) state.defaultProposalTemplate = t;
        });
    },

    loadRevShareProgramsState(state, data) {
        state.revShareSection.revSharePrograms = data;
    },
    loadPricingTablesState(state,data){
        state.savedPricingTables = data?.pricingTables.map(v =>{ 
            const entries = v.entries.map(entry =>{
                const item = {
                    id: entry.pricing_table_entry,
                    name: entry.description,
                    section: entry.section,
                    token: entry.value,
                    active: entry.active,

                }
                return createPricingTableItem(item)
            })
            const pricingTable = {pricing_table_id: v.pricing_table_id, name: v.name, entries: entries}
            let currentPricingTable = createPricingTable(pricingTable)
            // updatePricingTableDescriptions(currentPricingTable, state.dataContext)
            return currentPricingTable}) || []
    },

    clearSavedSelectedPricingTableState(state){
        state.savedSelectedPricingTable = ""
    },

    updateWholesalerTemplateState(state, data) {
        state.providerSection.load(data);
    },

    loadDefaultPricingState(state, data) {
        state.pricingSection.loadData(data);
    },

    loadDefaultPricingOptionsState(state, data) {
        state.pricingOptions = new PricingOptions(data);
    },

    loadBrokerDealersState(state, data) {
        state.brokerSection.loadOptions(data);
        state.advisorSection.loadBrokerOptions(data);
    },

    setAdvisorState(state, data) {
        // console.log('setAdvisorState called');
        state.advisorSection.loadAdvisorOptions(data);
    },

    clearAdvisorState(state) {
        state.advisorSection.reset();
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};
